import { render, staticRenderFns } from "./SVGApLoadProductImg.vue?vue&type=template&id=6385d2c0&scoped=true&"
import script from "./SVGApLoadProductImg.vue?vue&type=script&lang=js&"
export * from "./SVGApLoadProductImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385d2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6385d2c0')) {
      api.createRecord('6385d2c0', component.options)
    } else {
      api.reload('6385d2c0', component.options)
    }
    module.hot.accept("./SVGApLoadProductImg.vue?vue&type=template&id=6385d2c0&scoped=true&", function () {
      api.rerender('6385d2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGApLoadProductImg.vue"
export default component.exports